export const APP_NOTIFY = 'APP_NOTIFY'
export const APP_CLEAR_NOTIFICATION = 'APP_CLEAR_NOTIFICATION'

export const notify = (message, type = 'accept') => ({
  type: APP_NOTIFY,
  message,
  alertType: type,
})

export const clearNotification = () => ({
  type: APP_CLEAR_NOTIFICATION,
})

export const RESET_ERROR_MESSAGE = 'RESET_ERROR_MESSAGE'
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE'

// Resets the currently visible error message.
export const resetErrorMessage = () => ({
  type: RESET_ERROR_MESSAGE,
})

export const setErrorMessage = error => ({
  error,
  type: SET_ERROR_MESSAGE,
})



// WEBPACK FOOTER //
// ./src/utils/notification.js